import { forwardRef } from 'react';

import type { TextFieldModel } from '../../../types';
import Icon from '../../Icon';
import BaseStyleTextField from '../BaseStyleTextField';

import s from './BasicTextField.module.scss';

const BasicTextField = forwardRef<HTMLInputElement, TextFieldModel>(({ success, ...props }, ref) => {
  return (
    <BaseStyleTextField {...props} ref={ref}>
      {success && <Icon className={s.icon} type="check-mark" size={24} color="green.600" />}
    </BaseStyleTextField>
  );
});

export default BasicTextField;
